const BlueTick = () => {
  return (
    <div className='avatar w-5 align-bottom h-5'>
      <img
        src='https://cdn-icons-png.flaticon.com/512/1828/1828640.png'
        alt='verified'
      />
    </div>
  );
};

export default BlueTick;
